module.exports = "<location-selector event=\"eventCtrl.event\" update=\"eventCtrl.update({location})\"> </location-selector>\n<add-certificates event=\"eventCtrl.event\" location=\"eventCtrl.location\"></add-certificates>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/eventManager/event/certificates/template.html
// module id = 1813
// module chunks = 0